module.exports = __webpack_public_path__ + "static/media/close-circle.cafbcc9c.svg";